// @flow

import * as React from "react";

import { Error404Page } from "tabler-react";

type Props = {||};

const Error404 = (props: Props): React.Node => {
  return <Error404Page />;
}

export default Error404;



// WEBPACK FOOTER //
// ./src/errors/404.react.js